module.exports = __webpack_public_path__ + "img/finish-matte-white.94bb4f0e.jpg";